import styled from '@emotion/styled';
import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  DEFAULT_MOBILE_PADDING,
  BREAKPOINT_SMALL,
  DEFAULT_DESKTOP_PADDING,
  BREAKPOINT_MEDIUM,
  MarketingSection,
} from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';

export function SwitchQuotesSection() {
  const t = useT();
  return (
    <SwitchPageQuotesContainer>
      <SwitchQuotesTitle>
        {t(
          'ImportScreen.SwitchQuotesSection.Title',
          'Discover what our creators love most about Anchor',
          'Switch to Anchor page podcasters experiences section title'
        )}
      </SwitchQuotesTitle>
      <SwitchQuotesColumns>
        <SwitchQuote>
          <MarketingImage
            imagePath="switch/quotes/pretty-big-deal-cover"
            alt="Pretty Big Deal with Ashley Graham podcast cover"
            width={342}
            height={342}
          />
          <SwitchQuoteAuthor>Ashley Graham</SwitchQuoteAuthor>
          <SwitchQuotePodcast>Pretty Big Deal</SwitchQuotePodcast>
          <SwitchQuoteText>
            {t(
              'ImportScreen.SwitchQuotesSection.AshleyGrahamQuote',
              "“The show has given me the opportunity to talk to the most incredible guests and share these real, candid conversations with our audience. I love how through the podcast, I've been able to learn something new and hear other perspectives.”",
              'Switch to Anchor page podcaster experience using Anchor quote'
            )}
          </SwitchQuoteText>
        </SwitchQuote>
        <SwitchQuote>
          <MarketingImage
            imagePath="switch/quotes/optimum-living-daily-cover"
            alt="Optimum Living Daily with Justin Malik podcast cover"
            width={342}
            height={342}
          />
          <SwitchQuoteAuthor>Justin Malik</SwitchQuoteAuthor>
          <SwitchQuotePodcast>Optimum Living Daily</SwitchQuotePodcast>
          <SwitchQuoteText>
            {t(
              'ImportScreen.SwitchQuotesSection.JustinMalikQuote',
              "“Anchor has given us the clearest view into our audience demographics through their analytics dashboard, including gender and age, which we haven't seen anywhere else. Anchor's analytics has completely changed how we shape our new episodes—we can cater to our audience better than ever before.”",
              'Switch to Anchor page podcaster experience using Anchor quote'
            )}
          </SwitchQuoteText>
        </SwitchQuote>
        <SwitchQuote>
          <MarketingImage
            imagePath="switch/quotes/rumble-cover"
            alt="Rumble with Michael Moore podcast cover"
            width={342}
            height={342}
          />
          <SwitchQuoteAuthor>Michael Moore</SwitchQuoteAuthor>
          <SwitchQuotePodcast>Rumble</SwitchQuotePodcast>
          <SwitchQuoteText>
            {t(
              'ImportScreen.SwitchQuotesSection.MichaelMooreQuote',
              "“Anchor believes in the democratization of audio, pure and simple, and because of that, that's why I use this platform... Now, more than ever, our voices need to be heard.”",
              'Switch to Anchor page podcaster experience using Anchor quote'
            )}
          </SwitchQuoteText>
        </SwitchQuote>
      </SwitchQuotesColumns>
    </SwitchPageQuotesContainer>
  );
}

const SwitchPageQuotesContainer = styled(MarketingSection)`
  padding-bottom: ${DEFAULT_DESKTOP_PADDING}px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding-bottom: ${DEFAULT_MOBILE_PADDING}px;
  }
`;

const SwitchQuotesTitle = styled.h1`
  width: 90%;
  margin: 60px 0;
  font-weight: 800;
  font-size: 4rem;
  line-height: 1.2;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: auto;
    font-size: 2.5rem;
  }
`;

const SwitchQuotesColumns = styled.div`
  display: grid;
  grid-column-gap: ${DEFAULT_MOBILE_PADDING}px;
  grid-template-columns: repeat(3, 1fr);
  color: white;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    grid-column-gap: 0;
    margin: 0 -${DEFAULT_MOBILE_PADDING}px;
    overflow: auto;
    scroll-snap-type: x mandatory;
    scroll-snap-align: center;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const SwitchQuote = styled.blockquote`
  padding: 0;
  border: 0;
  font-size: 1.5rem;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    font-size: 1.25rem;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: 90vw;
    /**
     * This is a little tricky. Basically on mobile, we have a situation like
     * this:
     * +---------------------+        +----------------------+
     * |                     |        |                      |
     * +--+  +---------+  +--+        +----+  +-----------+  |
     * |  |  |         |  |  | scroll |    |  |           |  |
     * |  |  |         |  |  | +----> |    |  |           |  |
     * |  |  |         |  |  |        |    |  |           |  |
     * +--+  +---------+  +--+        +----+  +-----------+  |
     * |                     |        |                      |
     * +---------------------+        +----------------------+
     *
     * So we want some padding on the sides, but we also want the distance
     * between the cells to be correct. So, we add padding that will appear
     * correctly on the sides, and then shift the appropriate cells slightly to
     * make the space between the elements correct 
     */
    padding: 0 ${DEFAULT_MOBILE_PADDING}px;
    font-size: 1.125rem;
    scroll-snap-align: center;

    &:not(:first-of-type) {
      margin-left: -${DEFAULT_MOBILE_PADDING}px;
    }
  }
`;

const SwitchQuoteText = styled.p`
  color: white;
`;

const SwitchQuoteAuthor = styled.cite`
  display: block;
  margin-top: 40px;
  font-size: 85%;
  font-style: normal;
  line-height: 1.4;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-top: 20px;
  }
`;

const SwitchQuotePodcast = styled.div`
  margin-top: 5px;
  margin-bottom: 32px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    margin-bottom: 20px;
  }
`;
